import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // La sessione è gestita da un cookie httpOnly: verifichiamo con /auth/me
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (username, password, remember = false) => {
    const { data } = await api.post("/auth/login", { username, password, remember_me: remember });
    if (data.token) localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const loginPasskey = useCallback(async (remember = false) => {
    const { authenticatePasskey } = await import("@/lib/webauthn");
    const data = await authenticatePasskey(remember);
    if (data.token) localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    localStorage.removeItem("token");
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn("Logout lato server non riuscito (sessione locale comunque chiusa)", e);
    }
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({
      user, loading, login, loginPasskey, logout,
      isAdmin: !!user && (user.role === "admin" || user.role === "manager"),
      isSuperAdmin: !!user && user.role === "admin",
      isManager: !!user && user.role === "manager",
      isStaff: !!user && user.role === "staff",
      isPhotographer: !!user && user.role === "fotografo",
      isBarman: !!user && user.role === "barman",
      role: user ? user.role : null,
    }),
    [user, loading, login, loginPasskey, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
